import { useLocation, useNavigate } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { LmsPaths } from "routes/LmsRouter";
import { RootPaths } from "routes/RootRouter";

export const useGobackOrLms = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const goBack = () => {
        location.state && location.state["previousUrl"] != null
            ? navigate(location.state["previousUrl"])
            : location.key !== "default"
                ? navigate(-1)
                : navigate(LmsPaths.Home);
    };

    return goBack;
};

export const useGobackOrKnowledge = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const goBack = () => {
        location.state && location.state["previousUrl"] != null
            ? navigate(location.state["previousUrl"])
            : location.key !== "default"
                ? navigate(-1)
                : navigate(KnowledgePaths.FeedStartup);
    };

    return goBack;
};

export const useGobackOrHome = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const goBack = () => {
        location.state && location.state["previousUrl"] != null
            ? navigate(location.state["previousUrl"])
            : location.key !== "default"
                ? navigate(-1)
                : navigate(RootPaths.Home);
    };

    return goBack;
};
